/** * 系统管理 数据字典类型 */
<template>
  <div>
    <div class="query-select">
      <el-form :inline="true" :model="queryParams" class="user-search">
        <el-form-item label="字典名称">
          <el-input
            v-model.trim="queryParams.dictName"
            placeholder="请输入字典名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="字典类型">
          <el-input
            v-model.trim="queryParams.dictType"
            placeholder="请输入字典类型"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="queryParams.status"
            placeholder="请搜索状态"
            clearable
          >
            <el-option label="正常" value="0"></el-option>
            <el-option label="停用" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button plain round size="small"
          type="primary"
          icon="el-icon-search"
          @click="handleQuery"
          >查询</el-button
        >
        <el-button plain round size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetQuery"
          >重置</el-button
        >
        <el-button plain round size="small"
          type="success"
          icon="el-icon-plus"
          @click="dialogShow('add')"
          >新增</el-button
        >
        <el-button plain round size="small"
          type="primary"
          icon="el-icon-refresh"
          @click="handleRefreshCache"
          >刷新缓存</el-button
        >
      </div>
    </div>

    <div class="main-table">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        stripe
        header-cell-class-name="table-header"
        element-loading-text="拼命加载中"
        style="width: 100%;"
      >
        <el-table-column align="center" type="index" width="60" label="序号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="dictId"
          label="字典编号"
          width="100"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="dictName"
          label="字典名称"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="dictType"
          label="字典类型"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column align="center" prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '0' ? 'success' : 'info'">
              {{ scope.row.status === "0" ? "正常" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="remark"
          label="备注"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column align="center" label="操作" width="260" fixed="right">
          <template slot-scope="scope">
            <el-button plain round size="small"
              type="primary"
              @click="goDetail(scope.row)"
              >详情</el-button
            >
            <el-button plain round size="small"
              type="warning"
              @click="dialogShow('edit', scope.row)"
              >编辑</el-button
            >
            <el-button plain round size="small"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageparm.pageNum"
        :page-size="pageparm.pageSize"
        layout="total, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>

    <DictForm ref="formRef" @success="getList"></DictForm>
  </div>
</template>

<script>
import {
  getDictTypeList,
  deleteDictType,
  refreshDictCache
} from "@/api/system";
import { loadDictCache } from "@/utils/dict";
import DictForm from "./DictForm.vue";

export default {
  components: {
    DictForm
  },
  data() {
    return {
      loading: false,
      listData: [],
      totals: 0,
      pageparm: {
        pageNum: 1,
        pageSize: 10
      },
      queryParams: {
        dictName: "",
        dictType: "",
        status: ""
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageparm.pageNum,
        pageSize: this.pageparm.pageSize,
        dictName: this.queryParams.dictName || undefined,
        dictType: this.queryParams.dictType || undefined,
        status: this.queryParams.status || undefined
      };
      try {
        const result = await getDictTypeList(params);

        this.listData = (result.data && result.data.rows) || [];
        this.totals = (result.data && result.data.total) || 0;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange(val) {
      this.pageparm.pageNum = val;
      this.getList();
    },
    handleQuery() {
      this.pageparm.pageNum = 1;
      this.getList();
    },
    resetQuery() {
      this.queryParams = {
        dictName: "",
        dictType: "",
        status: ""
      };
      this.pageparm.pageNum = 1;
      this.getList();
    },
    dialogShow(type, row = {}) {
      this.$refs.formRef.open(type, row);
    },
    goDetail(row) {
      this.$router.push({
        path: "/system/dict/data",
        query: {
          dictType: row.dictType,
          dictName: row.dictName
        }
      });
    },
    async handleDelete(row) {
      try {
        await this.$confirm(`确定删除字典类型「${row.dictName}」吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        const result = await deleteDictType(row.dictId);

        this.$message.success("删除成功");
        this.getList();
      } catch (e) {}
    },
    async handleRefreshCache() {
      try {
        await this.$confirm("确定刷新字典缓存吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        await refreshDictCache();
        await loadDictCache();
        this.$message.success("刷新缓存成功");
      } catch (e) {}
    }
  }
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/Dict/index.vue